import React, { useEffect } from 'react'
import { Loading } from '../../uicomponents/mobile/Loading'
import { useDispatch, useSelector } from 'react-redux'
import NavBar from '../NavBar'
import Search from '../Search'
import SavedPlaces from '../SavedPlaces'
import { SmartBannerFullScreen } from '../../uicomponents/ui'
import { SkeletonApp } from '../../uicomponents/SkeletonApp'
import {
  enabledAlertsAndNewsComponent,
  resetPlacesSelected,
  setCurrentNavbarPosition,
  setOpenAlertInformation,
  setOpenStop,
  setSearch,
  setShowSearcher
} from '../../actions/ui'
import { useLocation } from 'react-router-dom'
import { Layout } from '../../uicomponents/layouts/Layout'
import { Home as Desktop } from '../../components/Desktop/Home'
import { Box, useMediaQuery } from '@mui/material'
import SendToPhoneModal from '../SendToPhoneModal'
import ShareModal from '../ShareModal'
import { CustomMap } from '../../uicomponents/Map'
import { REACT_APP_IS_IFRAME } from '../../constants/config'

export default function Home () {
  const dispatch = useDispatch()
  const { pathname } = useLocation()

  const mobile = useMediaQuery('(max-width:480px)')

  const cityConfig = useSelector(state => state?.ui?.cityConfig)
  const openCaptivePortal = useSelector(state => state?.ui.components.openSmartBanner)
  const stop = useSelector(state => state?.ui?.components?.stop)
  const alertsAndNews = useSelector(state => state?.ui?.alerts)
  const user = useSelector(state => state?.user?.auth)

  useEffect(() => {
    dispatch(setCurrentNavbarPosition(0))

    window.addEventListener('beforeinstallprompt', (event) => {
      // Prevents the default mini-infobar or install dialog from appearing on mobile
      event.preventDefault()
      // Save the event because you'll need to trigger it later.
      window.deferredPrompt = event
    })

    if (cityConfig) {
      dispatch(resetPlacesSelected())
    }
  }, [])

  useEffect(() => {
    dispatch(setSearch('', new Date()))
    if (!mobile) {
      if (pathname?.includes('news')) {
        if (stop?.enabled) {
          dispatch(setOpenStop(false))
          dispatch(setShowSearcher(true))
        }

        dispatch(enabledAlertsAndNewsComponent({ enabled: true }))

        if (pathname?.split('/')[2] && alertsAndNews?.length) {
          const current = alertsAndNews?.find((alert) => alert?.id === pathname?.split('/')[2])

          if (current) {
            dispatch(enabledAlertsAndNewsComponent({
              enabled: true,
              current: { ...current, isAlert: false }
            }))

            dispatch(setOpenAlertInformation(true))
          }
        } else if (pathname === '/news' && !alertsAndNews?.enabled) {
          dispatch(enabledAlertsAndNewsComponent({ enabled: true }))
          dispatch(setOpenAlertInformation(false))
        }
      }
    }
  }, [pathname])

  return (
    <Layout>
      {user
        ? (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              overflow: 'auto auto'
            }}
          >
            {mobile
              ? (
                <>
                  {!cityConfig && <Loading />}

                  {openCaptivePortal && pathname === '/'
                    ? <SmartBannerFullScreen />
                    : (
                      <>
                        <Box
                          sx={{
                            height: 'auto',
                            position: 'relative'
                          }}
                        >
                          <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            zIndex: 401
                          }}
                          >
                            <Search />
                            <SavedPlaces />
                          </div>
                          <CustomMap
                            showAdMarkers
                            showDraggableDestinationMarkers={false}
                            height='calc(100dvh - 68px)'
                          />
                        </Box>

                      </>
                      )}
                </>
                )
              : (
                <Desktop />
                )}
            {mobile && !REACT_APP_IS_IFRAME && <NavBar />}
            <SendToPhoneModal />
            <ShareModal />
          </Box>
          )
        : (
          <SkeletonApp />
          )}
    </Layout>
  )
}
